/* External */
import mapValues from 'lodash/mapValues';
import forEach from 'lodash/forEach';

/**
 * @enum {number}
 * @readonly
 */
export const TypeDefType = {
  NATIVE: 0,
  ARRAY: 1,
  OBJECT: 2,
  SHAPE: 3,
};

export const ENTITY_DEFINED_LATER = 'entity-defined-later';

export function createExpectedTypedefError(receivedDefinition) {
  const error = new Error('Expected a typedef');
  error.data = {
    receivedDefinition,
  };

  return error;
}

export const identity = (v) => v;

export const returnNull = () => null;

export const deserializeString = (value) => `${value}`;

export const deserializeNumber = (value) => Number.parseFloat(value);

export const deserializeDate = (value) => new Date(value);

export const deserializeBoolean = (value) => {
  if (typeof value === 'string') {
    return value === 'true' || !!Number.parseInt(value, 10);
  }

  return !!value;
};

export function createShapeDeserializer(shapeDefinition) {
  if (process.env.NODE_ENV === 'development') {
    forEach(shapeDefinition, (typeDefinition) => {
      if (!typeDefinition.isTypeDef) {
        const error = createExpectedTypedefError(typeDefinition);
        throw error;
      }
    });
  }

  return (object) => mapValues(
    shapeDefinition,
    (typeDefinition, prop) => typeDefinition.deserializer(object[prop]),
  );
}

const shapeDefaultValueMapFunction = (typeDefinition) => typeDefinition.defaultValue;
export function getShapeDefaultValue(shapeDefinition) {
  return mapValues(shapeDefinition, shapeDefaultValueMapFunction);
}

const composeCallback = (previousValue, func) => func(previousValue);
export function compose(...functions) {
  return (argument) => functions.reduce(
    composeCallback,
    argument,
  );
}
